import RouteContainer from 'containers/RouteContainer';
import Component from './containers/FloodlightContainer';

export const path = `${DOCUMENTS_PATH}/floodlight`;
export const navigation = { name: 'floodlight', id: 'floodlight.title', nonNavigable: true };

export default RouteContainer(path, Component);
